import styled from 'styled-components';
import { layout } from 'tokens';

export const Base = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	box-sizing: border-box;
	height: ${layout.inspectorNavbarHeight}px;
	--navbar-height: ${layout.inspectorNavbarHeight}px;
	background: ${({ theme }) => theme.gray[0]};
	gap: 0px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
`;
